import * as React from 'react';

import { Currency } from '@shared/components/helpers';

import { PricingGroupPricingEntryFragment } from '@admin/schema';

export const ProtectionTotal: React.FC<{
  protection?: PricingGroupPricingEntryFragment;
}> = ({ protection }) => {
  if (!protection) {
    return <>-</>;
  }
  return <Currency value={protection.pricing.amount} />;
};
